// extracted by mini-css-extract-plugin
export default {"content":"Topic_content__Lyf3L","title":"Topic_title__NWntr","info":"Topic_info__1wYy8"};